export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/logo-research.1b64fc40.svg","height":30,"width":156,"blurWidth":0,"blurHeight":0};